export const DarkenColor = (hex: string, percent: number) => {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);

  const darken = (color: number, value: number) =>
    Math.max(0, Math.round(color * (1 - value)));

  const darkenedR = darken(r, percent);
  const darkenedG = darken(g, percent);
  const darkenedB = darken(b, percent);

  return `#${darkenedR.toString(16).padStart(2, '0')}${darkenedG
    .toString(16)
    .padStart(2, '0')}${darkenedB.toString(16).padStart(2, '0')}`;
};

export const LightenColor = (hex: string, percent: number) => {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);

  const lighten = (color: number, value: number) =>
    Math.min(255, Math.round(color * (1 + value)));

  const lightenedR = lighten(r, percent);
  const lightenedG = lighten(g, percent);
  const lightenedB = lighten(b, percent);

  return `#${lightenedR.toString(16).padStart(2, '0')}${lightenedG
    .toString(16)
    .padStart(2, '0')}${lightenedB.toString(16).padStart(2, '0')}`;
};
